import React from "react";

import { AdminPanelLayout } from "../../components/AdminPanelLayout";
import { BrigadesList } from "../../components/BrigadesList";
import { useBrigades } from "../../hooks/brigades/use-brigades";
import { useSelectedBrigade } from '../../hooks/brigades/use-selected-brigade';
import { BrigadeForm } from '../../components/BrigadeForm';

export const BrigadesPage: React.FC = () => {
  const { data: brigades, isSuccess, isLoading, isError } = useBrigades();
  const selectedBrigade = useSelectedBrigade();

  return (
    <AdminPanelLayout
      leftPanel={
        <>
          {isLoading && (
            <div className="spinner-border d-block m-auto" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          )}

          {isError && (
            <div className="alert alert-danger d-block m-auto" role="alert">
              Помилка під час завантаження бригад
            </div>
          )}

          {isSuccess && <BrigadesList brigades={brigades} />}
        </>
      }
      rightPanel={<BrigadeForm />}
    />
  );
};
